<template>
  <div>
    <ul class="sign-up-nav navbar-nav">
      <li
          class="nav-item scc-nav-item"
          v-for="(itemMenuSettings, index) in menuSettings"
          :key="index"
      >
        <router-link
            class="nav-link hover-item-a"
            v-if="(itemMenuSettings.showForAuth&&authDonor)||(!itemMenuSettings.showForAuth&&!authDonor)"
            :to="itemMenuSettings.href"
          >
          {{itemMenuSettings.banner}}
          <font-awesome-icon class="awesome-icon" :icon="['fas', 'bell']" v-if="index==='rewards'"/>
        </router-link>
      </li>
      <li class="nav-item scc-nav-item">
        <a
            class="nav-link hover-item-a" v-on:click="logout"
            v-if="authDonor"
        >| Logout</a>
      </li>
    </ul>
  </div>

</template>

<script>
import { mapState } from 'vuex';
export default {
  name: "signUpMenu",
  data(){
    return {
      menuSettings: {
        rewards: {
          banner: '', // <i class="fas fa-bell"></i>
          href: '/rewards-store',
          showForAuth: true,
        },
        login: {
          banner: 'Login',
          href: '/login-donor',
          showForAuth: false,
        },
        donorProfile: {
          banner: 'Donor profile',
          href: '/donor-profile',
          showForAuth: true,
        },
      },
    }
  },
  computed : {
    ...mapState({
      authDonor: state => state.auth.authDonor,
      donorFirstName: state => state.donorInformation.firstName,
      donorLastName: state => state.donorInformation.lastName,
    })
  },
  watch:{
    donorFirstName: function(val){
      this.menuSettings.donorProfile.banner = 'Profile | Welcome, ' + val
    }
  },
  created() {
    this.menuSettings.donorProfile.banner = 'Profile | Welcome, ' + this.donorFirstName
  },
  methods:{
    logout(){
      console.log('LOGOUT');
      this.$store.dispatch('auth/SET_logout', 'standard')
      this.$router.push('/')
    },
    createProfileLabel(){

    }
  }
}
</script>

<style scoped>
  .sign-up-nav {
    flex-direction: row;
  }
  .navbar-nav .scc-nav-item a {
    display: inline-block;
    font-size: 15px;
    color: var(--BasicFontColor);
    text-decoration: none;
    margin: 0 0 0 5px;
    position: relative;
    padding: 0;

    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 300px;
  }
  .navbar-nav .scc-nav-item a:hover {
    color: var(--ButtonColor);
  }
  .hover-item-a:before {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    -webkit-transform: scaleX(0);
    -ms-transform: scaleX(0);
    transform: scaleX(0);
    height: .125rem;
    bottom: .125rem;
    left: .0625rem;
    top: 1.25rem;
    background-color: var(--BasicFontColor);
    -webkit-transform-origin: 100% 50%;
    -ms-transform-origin: 100% 50%;
    transform-origin: 100% 50%;
    transition: -webkit-transform .4s cubic-bezier(.23,1,.32,1);
    transition: transform .4s cubic-bezier(.23,1,.32,1);
    transition: transform .4s cubic-bezier(.23,1,.32,1),-webkit-transform .4s cubic-bezier(.23,1,.32,1);
  }
  .hover-item-a:focus:before, .hover-item-a:hover:before {
    -webkit-transform: scaleX(1);
    -ms-transform: scaleX(1);
    transform: scaleX(1);
    -webkit-transform-origin: 0 50%;
    -ms-transform-origin: 0 50%;
    transform-origin: 0 50%;
  }
  .awesome-icon{
    color: #e11313;
  }
</style>